import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { Customer, RouseCategory } from 'src/app/core/models';
import { ComponentBase } from '../component.base';

@Component({
  selector: 'app-categories',
  templateUrl: './categories.component.html',
  styleUrls: ['./categories.component.scss'],
  standalone: false,
})
export class CategoriesComponent
  extends ComponentBase
  implements OnInit, OnDestroy
{
  hasCategoriesSubscription = false;
  rouseCategories?: Array<RouseCategory> = undefined;
  public allAssetsLabel: string = 'main.data.all_assets';
  public appliedFilters: string = '';

  ngOnInit(): void {
    this.authenticationService.startSentryTransaction(
      this.router.routerState.snapshot.url
    );
    this.subscriptions.push(
      this.translateService.onDefaultLangChange.subscribe((r) => {
        this.allAssetsLabel = this.translateService.instant(
          'main.data.all_products'
        );
      })
    );
    this.subscriptions.push(
      this.profileService.selectedCustomersChanged.subscribe(
        (r: Array<Customer>) => {
          this.loadPageData();
        }
      )
    );
    this.allAssetsLabel = this.translateService.instant(
      'main.data.all_products'
    );
    this.navService.showBackButton = false;
    // caching the result so it doesn't get spammed.
    this.appliedFilters = this.filtersService.appliedFilters;
  }

  ngOnDestroy() {
    this.subscriptions.forEach((s: Subscription) => {
      s.unsubscribe();
    });
  }

  onItemClick = (category: RouseCategory): void => {
    this.openProductType(category);
  };

  getSelectedCustomerCount(): number {
    return this.profileService.getSelectedCustomers().length;
  }

  loadPageData() {
    console.log('categories.component.loadPageData  called');
    super.loadPageData();
    this.isBusy = true;
    this.rouseCategories = this.equipmentService.rouseCategories;
    // if (!this.rouseCategories) {
    if (!this.hasCategoriesSubscription) {
      this.subscriptions.push(
        this.equipmentService.rouseCategoriesLoaded.subscribe(
          (rouseCategories) => {
            this.rouseCategories = rouseCategories;
            this.isBusy = false;
            this.authenticationService.finishSentryTransaction();
          }
        )
      );
      this.hasCategoriesSubscription = true;
    }
    this.equipmentService.getCategories();
    // } else {
    //   this.isBusy = false;
    //   this.authenticationService.finishSentryTransaction();
    // }
  }

  private openProductType = (category: RouseCategory) => {
    this.equipmentService.productTypes = undefined;
    this.navService.pageTitle =
      category.category_id !== -999
        ? category.category_name
        : this.translateService.instant('main.data.all_products');
    this.router.navigate(['/product-types', category.category_id]);
  };
}
